export default "/_next/static/images/2dc2f26129acb5d1bfcc3b84b18db480.jpg";